import { Link } from 'react-router-dom';
import { BRAND_LOGO } from '@/lib/brand.js';

/** Proporção natural do PNG Hack Academy. */
const LOGO_ASPECT = 1701 / 332;

type BrandLogoProps = {
  height?: number;
  className?: string;
  linkTo?: string | null;
};

export function BrandLogo({ height = 28, className, linkTo = '/' }: BrandLogoProps) {
  const src = BRAND_LOGO.onLight;

  const img = (
    <img
      src={src}
      alt="Hack Academy"
      style={{
        height,
        width: height * LOGO_ASPECT,
        maxWidth: '100%',
        aspectRatio: '1701 / 332',
        objectFit: 'contain',
        display: 'block',
      }}
      className={className}
      decoding="async"
    />
  );

  if (linkTo === null) return img;

  return (
    <Link to={linkTo} className="inline-flex shrink-0 items-center" style={{ lineHeight: 0 }}>
      {img}
    </Link>
  );
}
